import { graphql } from 'gatsby';
import React from 'react';
import { useMicrosite } from '../../contexts/franchise/microsite-context/index.tsx';
import Container from '../atoms/Container';
import { colors } from '../primitives/colors/index.tsx';
import RichText from '../primitives/richtext/index.tsx';
import paddingDefault from '../utils/paddingDefault';

const styles = {
    containerWrap: {
        backgroundColor: colors.grey100,
    },
    title: {
        fontSize: '36px',
        marginBottom: '1rem',
        lineHeight: 1.25,
        '@media (min-width: 1024px)': {
            marginBottom: '1.5rem',
        },
    },
    copyWrap: {
        fontSize: '1.125rem',
        lineHeight: '1.75rem',
        '@media (min-width: 1024px)': {
            fontSize: '1.25rem',
        },
    },
    franchiseRichTextEditorStyles: {
        p: { marginBottom: '1.2rem' },
        'strong,h1,h2,h3,h4,h5': { fontWeight: 'bold', margin: '2rem 0 0.5rem' },
        i: { fontStyle: 'italic' },
        padding: '0',
        margin: '0',
        whiteSpace: 'pre-line',
    },
};

const FranchiseCollapsibleAbout = ({ data: { title } }) => {
    const microsite = useMicrosite();
    const copy = (microsite?.franchise?.profileExcerpt || '');

    if (!copy) {
        return null;
    }

    return (
        <div css={[paddingDefault(), styles.containerWrap]}>
            <Container>
                <div>
                    <h2 css={styles.title}>{title}</h2>
                    <RichText maxLength={4} css={[styles.franchiseRichTextEditorStyle, styles.copyWrap]}>
                        {copy}
                    </RichText>
                </div>
            </Container>
        </div>
    );
};


export const query = graphql`
  fragment FranchiseCollapsibleAboutData on CmsPageBuilderBlocks {
    franchise_collapsible_about { 
      title
    }
  }
`;

export default FranchiseCollapsibleAbout;
